import StickyNote2OutlinedIcon from "@mui/icons-material/StickyNote2Outlined";
import React from "react";
import { useTranslation } from "react-i18next";
import EmptyState from "../../../../common/EmptyState";

const NoApplicationNotesFound: React.FC = () => {
	const { t } = useTranslation();

	return (
		<EmptyState
			icon={
				<StickyNote2OutlinedIcon
					sx={{
						fontSize: 80,
						color: "white"
					}}
				/>
			}
			title={t("freelancerDetails.notes.noNotesFound.title")}
			message={t("freelancerDetails.notes.noNotesFound.message")}
			iconBackgroundGradient="linear-gradient(135deg, #667eea 0%, #764ba2 100%)"
			iconBoxShadow="0 8px 25px rgba(102, 126, 234, 0.3)"
			containerMinHeight="300px"
			titleVariant="h5"
			containerSx={{ maxWidth: 500, pt: 4 }}
		/>
	);
};

export default NoApplicationNotesFound;
